
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import InfiniteLoading from 'vue-infinite-loading';
import {getLastDeviceData, modifyPointData} from "@/api/deviceData";
import {getDeviceConfigByDeviceId} from "@/api/deviceConfig";
import {isEmpty, debounce} from "@/utils/hlf";

export default {
data() {
return {
deviceId: '',
devConf: {},
maxLevel: 0,
devConfPic: {},
devPicWx: '',
lastData: [],
lastDataMap: {},

currItem: {},
dataPoints: {
voltA: {},
voltB: {},
voltC: {},
elecA: {},
elecB: {},
elecC: {},
ammeter: {},
waterMeter: {},
envTemp: {},
waterLevels: [],
temps: [],
relays: [],
params: [],
timers: [],
charts: [],
},

buttonBoxData: {},

setParams: {},

setTimes: {},

buttonBoxDataNames: [
'继电器远程开关',
'电辅热',
'补水电磁阀',
'回水电磁阀',
'继电器7'
],
dialogViewShowStyle: {
'transform': 'rotate(90deg)'
},
fullscreen: false,
showButtonBox: true,
buttonBoxFlag: false,

setParamsViewShow: false,

setTimesViewShow: false,

editShow: false,

switchShow: false,

waterBoxStyleObject: {},

buttonBoxStyleObject: {},

toolButtonStyleObject: {},

switchPoints: {},

chartValues: {},
airEnergyObject: {},
frequencyChangerObject: {},
imgHeight: "800px",

waterBoxHeight: '20%',

waterBoxTemperatureDataValue: 0
}
},
name: "device-pic",
components: {
Grid,
GridItem,
CellBox,
XButton,
Group,
Flexbox,
FlexboxItem,
Toast,
Icon,
InlineXSwitch,
Card,
InfiniteLoading,
Confirm,
Popup,
XDialog
},
directives: {
TransferDom
},
methods: {
getDeviceConfig() {
getDeviceConfigByDeviceId(this.deviceId).then(response => {
this.devConf = JSON.parse(response.data.dataJson);
this.devConfPic = JSON.parse(response.data.picDataJson);
this.devPicWx = process.env.VUE_APP_BASE_API + response.data.picWx;
this.maxLevel = response.data.maxLevel || 100;
this.getLastData();
});
},
getLastData() {
getLastDeviceData(this.deviceId).then(response => {
this.lastData = response.data;
this.lastData.forEach(item => {
this.lastDataMap[item.pointId] = item;
})
console.log(this.lastData, "lastData");
console.log(this.lastDataMap, "lastDataMap");
this.assembleData();
this.computedPosition();
setTimeout(() => {
try {
this.computedPosition();
} catch (e) {
console.error(e, "computedPosition error");
}
}, 1000);
});
},
checkIsEdit(pId) {
let lastData = this.lastDataMap[pId];
if (!pId || !lastData || !lastData.dataPointDto) {
return false;
}
return lastData.dataPointDto.writeRead == '1' || lastData.dataPointDto.writeRead == '2';
},
handleClassifyData(type) {
if (type == 'param') {
this.setParamsViewShow = true;
this.setParams = this.dataPoints.params;
}else if (type == 'time') {
this.setTimesViewShow = true;
this.setTimes = this.dataPoints.timers;
}
},
computedPosition() {
let devConfPic = this.devConfPic;
if (!devConfPic) {
return;
}
let bgEle = document.getElementById('bg');
if (!bgEle) return
this.bgCW = bgEle.offsetWidth
this.bgCH = bgEle.offsetHeight
let wPercent = this.bgCW / 380
let hPercent = this.bgCH / 880
let t = hPercent * devConfPic.wxWater.t
let r = wPercent * devConfPic.wxWater.r
let w = wPercent * devConfPic.wxWater.w
let h = hPercent * devConfPic.wxWater.h
this.waterBoxStyleObject = {
top: t + 'px',
right: r + 'px',
height: h + 'px',
width: w + 'px'
}

this.buttonBoxStyleObject = {
right: wPercent * 10 + 'px',
top: '540px'
}


this.toolButtonStyleObject = {
right: wPercent * 15 + 'px',
bottom: '0px'
}

this.computeWaterBoxHeight();
if (isEmpty(this.devConfPic.wx)) {
return;
}
this.devConfPic.wx.forEach(pointItem => {
if (!isEmpty(pointItem.pId) && !isEmpty(pointItem.pName) && !isEmpty(pointItem.r) && !isEmpty(pointItem.t)) {
let lastData = this.lastDataMap[pointItem.pId]
if (isEmpty(lastData)) {
lastData = {}
}
if (!lastData.value) {
pointItem.value = 0;
}
if (!isEmpty(lastData.dataPointDto)) {
if (lastData.dataPointDto.type == 1) {

this.switchPoints[pointItem.pId] = {
className: lastData.value == '0' ? 'switch-off' : 'switch-on',
}
this.switchPoints[pointItem.pId].styleObject = {
right: wPercent * pointItem.r + 'px',
top: hPercent * pointItem.t + 'px',
width: wPercent * 10 + 'px',
height: hPercent * 10 + 'px'
}
this.switchPoints[pointItem.pId].lastData = lastData;
} else {

this.chartValues[pointItem.pId] = {}
this.chartValues[pointItem.pId].styleObject = {
right: wPercent * pointItem.r + 'px',
top: hPercent * pointItem.t + 'px',
}
this.chartValues[pointItem.pId].lastData = lastData;
}
}
}
})
},

assembleData() {
if (this.devConf) {
let configs = Object.keys(this.dataPoints);
configs.forEach(v => {
let configItem = this.devConf[v];
if (!isEmpty(configItem)) {
if (this.dataPoints[v] instanceof Array) {
if (!isEmpty(configItem.pId) && !isEmpty(configItem.pName)
&& configItem.pId instanceof Array && configItem.pName instanceof Array) {
this.dataPoints[v] = []
configItem.pId.forEach((id, index) => {
let value = undefined;
if (this.lastDataMap[id]) {
value = this.lastDataMap[id].value;
}
this.dataPoints[v].push({pId: id, pName: configItem.pName[index], value: value});
})
}
} else {
if (!isEmpty(configItem.pId) && !isEmpty(configItem.pName)) {
this.dataPoints[v].pId = configItem.pId;
this.dataPoints[v].pName = configItem.pName;
if (this.lastDataMap[configItem.pId]) {
this.dataPoints[v].value = this.lastDataMap[configItem.pId].value;
}
}
}
}
})
console.log(this.dataPoints, "dataPoints");
}
},
computeWaterBoxHeight() {

let waterBoxHeight;
try {
waterBoxHeight = Number(this.lastDataMap[this.devConfPic.wxWaterLevel.pId].value) / (Number(this.maxLevel)) * 100;
} catch (e) {
console.error(e, "waterBoxHeight error")
}
if (typeof waterBoxHeight !== 'number' || isNaN(waterBoxHeight)) {
waterBoxHeight = 0;
}
this.waterBoxHeight = parseInt(waterBoxHeight) + "%";
},
openSetDataDialog(item){
this.currItem = item;
this.editShow = true;
this.setParamsViewShow = false
this.setTimesViewShow = false
},
onConfirmEdit(value) {
if (value) {
this.editDataPoints(value, false);
} else {
this.$vux.toast.show({
type: 'warn',
text: '设置值不能为空'
})
}
},
onCancelEdit(){

},
changeSwitch(item) {
this.currItem = item;
this.switchShow = true;
},
onConfirmSwitch() {
this.editDataPoints(null, true);
},
buttonClassNameSelect(item) {
return item.value == '1' ? 'green' : 'red'
},
onCancelSwitch () {
this.currItem = {}
},
editDataPoints(value, isSwitch) {
console.log(this.currItem, 666);
let oldValue;
let data = this.currItem;
oldValue = this.currItem.value
if (isSwitch) {
data.value = this.currItem.value == '1' ? '0' : '1';
} else {
data.value = value;
}
modifyPointData(data).then(response => {
this.$vux.toast.show({
text: '修改成功',
time: 3000
})
}).catch(error => {
this.currItem.value = oldValue;
this.$vux.toast.show({
type: 'warn',
text: error
})
});
},
fullScreen() {

let element = document.documentElement;
if (this.fullscreen) {
if (document.exitFullscreen) {
document.exitFullscreen();
} else if (document.webkitCancelFullScreen) {
document.webkitCancelFullScreen();
} else if (document.mozCancelFullScreen) {
document.mozCancelFullScreen();
} else if (document.msExitFullscreen) {
document.msExitFullscreen();
}
this.fullscreen = false;
} else {
if (element.requestFullscreen) {
element.requestFullscreen();
} else if (element.webkitRequestFullScreen) {
element.webkitRequestFullScreen();
} else if (element.mozRequestFullScreen) {
element.mozRequestFullScreen();
} else if (element.msRequestFullscreen) {

element.msRequestFullscreen();
}
this.fullscreen = true;
}

},
calcImgHeight() {
this.imgHeight = document.documentElement.clientHeight + 'px';
},
},
created() {
this.deviceId = this.$route.params.id;
},
mounted() {
setInterval(() => {
this.calcImgHeight();
}, 500)
this.getDeviceConfig()

let current = this
window.onresize = debounce(function () {
current.computedPosition()
}, 500, false)
},
computed: {

dynamicClass: function () {
let tmp = this.waterBoxTemperatureDataValue;
return {
'waterBox': true,
'cold': tmp < 39,
'warm': tmp >= 39 && tmp < 55,
'hot': tmp >= 55
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/device-pic.vue